import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import CandidateForm from "@/components/CandidateForm";

export default function ApplyModal({ job, onClose, category = false }) {
  const open = Boolean(job);
  const title = job?.title || "";
  const description = category
    ? "Join the ArcPoint senior leadership network. We're building long-term relationships with exceptional UK operators — for future confidential mandates, strategic introductions and market conversations."
    : `${job?.location || ""}${job?.salary ? ` · ${job.salary}` : ""}`;
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        data-testid="apply-modal"
        className="max-w-2xl bg-[#15315F] border border-[#C9A876]/30 text-white rounded-none p-0 overflow-hidden"
      >
        <div className="p-8 md:p-10 max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <span className="font-mono-eyebrow text-[#C9A876]">
              ◆ {category ? "Register Interest — Confidential" : "Confidential Application"}
            </span>
            <DialogTitle className="font-display text-3xl md:text-4xl tracking-tight text-white mt-3 leading-tight">
              {title}
            </DialogTitle>
            <DialogDescription className="text-sm text-slate-300/80 mt-3">
              {description}
            </DialogDescription>
          </DialogHeader>
          <div className="hairline my-8" />
          <CandidateForm
            jobId={category ? null : job?.id}
            jobTitle={title}
            compact
            onSuccess={onClose}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
